<template>
  <div>
    <Modal v-model="modal" width="360" footer-hide :styles="{top: '20%'}" class="error-modal">
      <div style="text-align:center">
        <img src="~assets/img/onlineblock/attentionmulticolor.png" alt="">
        <p>确定要删除联系人吗？</p>
        <div class="btngroup">
          <Button class="btn" type="default" @click="modal = false">取消</Button>
          <Button class="btn" type="error"  @click="deleteConfirm">确认</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "ModalDelete",
  props: ["obj","deleteModal"],
  computed:{
    modal:{
      get(){
        return this.deleteModal
      },
      set(val){
        this.$emit("update:deleteModal",val)
      }
    }
  },
  methods:{
    //結束對話
    deleteConfirm () {
      this.modal = false
    },
  }
}
</script>